<template>
  <div class="timeline">
    <svg :width="svgWidth" :height="svgHeight">
      <rect width="100%" height="2px" x="0" y="0" :fill="getLineColor" />
      <g v-for="label in labels" :key="label.position">
        <text
          class="timeline__label-text"
          :x="`${label.labelPosition}%`"
          y="100%"
        >
          {{ label.label }}
        </text>
        <rect
          width="2px"
          :height="getHeight(label.i)"
          :data-position="label.position"
          y="2px"
          :x="`${label.position}%`"
          :fill="getLineColor"
        />
      </g>
    </svg>
  </div>
</template>

<script>
import moment from "moment";
import { timeFormatConfigs } from "../../configs";

const getLabelWidth = (type, width) => {
  switch (type) {
    case "second":
      return (92 / width) * 100;
    case "minute":
      return (78 / width) * 100;
    case "hour":
      return (66 / width) * 100;
    case "day":
      return (52 / width) * 100;
    case "month":
      return (37 / width) * 100;
    case "year":
      return (24 / width) * 100;
  }
};

export default {
  props: ["max", "min", "format", "time-min", "time-max"],
  watch: {
    format: function() {
      this.changeTimeline();
    },
    min: function() {
      this.changeTimeline();
    },
    max: function() {
      this.changeTimeline();
    }
  },
  data() {
    return {
      svgHeight: 24,
      svgWidth: 720,
      labels: [],
      maxLabelsConfig: {
        year: 16,
        month: 10,
        day: 8,
        hour: 6,
        minute: 6,
        second: 5
      }
    };
  },
  computed: {
    getLineColor() {
      return this.$store.state.theme === "dark-theme" ? "#1d1e27" : "#c1c1c4";
    }
  },
  methods: {
    changeTimeline() {
      const maxCount = this.maxLabelsConfig[this.format];
      const timeLength = this.max - this.min;
      let step = 1;

      this.labels = [];

      if (timeLength > maxCount) {
        const div = Math.floor(timeLength / maxCount);
        step = div === 1 ? 2 : div;
      }

      for (let i = 0; i <= timeLength; i += step) {
        const diffFormat = `${this.format}s`;
        const label = moment(this.timeMin)
          .add(i, diffFormat)
          .format(timeFormatConfigs[this.format]);
        const strokeWidth = (2 / this.svgWidth) * 100;
        let position = i === 0 ? 0 : (i / timeLength) * 100 - strokeWidth / 2;
        // const timeValue = moment(this.timeMin).add(i, diffFormat).valueOf() - this.timeMin;
        // const timelineWidth = this.timeMax - this.timeMin;
        // const position = i === 0 ? 0 : ((timeValue / timelineWidth) * 100) - ((1 / this.svgWidth) * 100);
        if (position + strokeWidth > 100) position = 100 - strokeWidth;
        const labelWidth = getLabelWidth(this.format, this.svgWidth);
        let labelPosition = i === 0 ? 0 : position - labelWidth / 2;

        if (labelPosition + labelWidth > 100) labelPosition = 100 - labelWidth;

        this.labels.push({ i, label, position, labelPosition });
      }
    },
    getHeight(i) {
      if (i === 0 || i === this.max) return "10px";
      return "6px";
    }
  },
  created() {
    this.changeTimeline();
  }
};
</script>

<style lang="scss">
.timeline {
  &__label-text {
    font-size: 10px;
    fill: var(--text_secondary) !important;
  }
}
</style>
